import type React from 'react';
import type { GlobalToken } from 'antd';

// The summary card and the check cards stack directly against each other on the
// diagnostics report, so their outlines must not drift apart. Only the outline is
// shared — each card still picks its own background and padding.
export const reportCardChrome = (token: GlobalToken): React.CSSProperties => ({
  border: `${token.lineWidth}px solid ${token.colorBorderSecondary}`,
  borderRadius: token.borderRadiusLG,
});
